<template>
    <div v-if="purchaseOrders">
        <v-toolbar flat color="orange" dark>
            <v-toolbar-title>Purchase Orders</v-toolbar-title>
        </v-toolbar>
        <v-container fluid>
            <v-card>
                <v-card-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :loading="this.$apollo.queries.purchaseOrders.loading"
                        :headers="headers"
                        :items="purchaseOrders.data"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :search="search"
                        :page.sync="page"
                        :items-per-page.sync="pageCount"
                        :server-items-length="purchaseOrders.paginatorInfo.lastPage * pageCount"
                >
                <template v-slot:item.company="{ item }">
                    <router-link :to="{name: 'customer-view', params: {id: item.id}}" small>
                        {{item.company}}
                    </router-link>
                </template>

                <template v-slot:item.xeroPoNumber="{ item }">
                    <v-btn :to="{name: 'purchase-order-view', params: {id: item.id}}" small>
                        <template v-if="item.xeroPoNumber">
                            {{item.xeroPoNumber}}
                        </template>
                        <template v-else>
                            {{item.id}}
                        </template>
                    </v-btn>
                </template>

                <template v-slot:item.date="{ item }">
                    {{ item.date | formatDate}}
                </template>

                <template v-slot:item.acknowledgedAt="{ item }">
                    <v-chip v-if="item.acknowledgedAt" color="light-green">{{ item.acknowledgedAt | formatDate}}</v-chip>
                </template>

                </v-data-table>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import PURCHASE_ORDER_LIST from "../graphql/PurchaseOrder/List.gql";

    export default {
        metaInfo: {
            title: `Purchase Orders`
        },
        apollo: {
            purchaseOrders:{
                query: PURCHASE_ORDER_LIST,
                variables () {

                    let where =  { column: 'PURCHASE_ORDER_DATE', operator: 'IS_NOT_NULL'}
                    if(this.search !== ''){
                        where = { column: 'COMPANY', operator: 'LIKE', value: '%'+this.search+'%' }
                    }

                    let sortField = this.sortBy[0] ? this.sortBy[0] : 'Purchase_Order_Date'
                    let sortDirection = this.sortDesc[0] ? 'DESC' : 'ASC'

                    if(sortField === 'xeroPoNumber') {
                        sortField = 'xero_po_number'
                    }

                    if(sortField === 'date') {
                        sortField = 'Purchase_Order_Date'
                    }

                    if(sortField === 'contactPostcode') {
                        sortField = 'PostCode'
                    }


                    return {
                        first: this.pageCount,
                        page: this.page,
                        where: where,
                        orderBy: { field: sortField.toUpperCase(), order: sortDirection },
                    }
                },
                update: data => data.purchaseOrders
            } ,
        },
        data() {
            return {
                search: '',
                page: 1,
                pageCount: 15,
                sortBy: ['date'],
                sortDesc: [true],
                headers: [
                    {
                        text: 'ID',
                        align: 'start',
                        value: 'xeroPoNumber',
                    },
                    {
                        text: 'Date',
                        align: 'start',
                        value: 'date',
                    },
                    {
                        text: 'Company',
                        align: 'start',
                        value: 'company',
                    },
                    {
                        text: 'Contact',
                        align: 'start',
                        value: 'contact',
                    },
                    {
                        text: 'Acknowledged',
                        align: 'start',
                        value: 'acknowledgedAt',
                    },
                ],
            }
        },
    }
</script>
